export const hhmmRE = /^(\d{1,2}):(\d\d)(?::(\d\d))?$/;

export const getSecondsFromHHmm = ( hhmm:string ) => {
    const matches = hhmm.match(hhmmRE);
    if( !matches )
        throw Error(`'${hhmm}' does not match HH:mm`);
    const hours    = Number(matches[1]);
    const minutes  = (60*hours)+Number(matches[2]);
    const seconds  = (60*minutes)+Number(matches[3]||0);
    return seconds;
}

export const getHHmmFromSeconds = ( s:number, skipSeconds?:boolean ) => {
    const seconds = Math.floor(s%60);
    s = (s-seconds)/60;
    const minutes = Math.floor(s%60);
    const hours   = Math.floor((s-minutes)/60);
    if( seconds>0 && !skipSeconds )
        return `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;
    return `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}`;
}

export const getHHMMFromMins = (mins: number): string => {
    const hours = String(Math.floor(mins / 60));
    const mins_ = String(mins % 60);
    return `${hours.padStart(2, "0")}:${mins_.padStart(2, "0")}`;
}
